import { render } from "./NewRowNicheModal.vue?vue&type=template&id=5d9d14f0"
import script from "./NewRowNicheModal.vue?vue&type=script&lang=js"
export * from "./NewRowNicheModal.vue?vue&type=script&lang=js"

import "./NewRowNicheModal.vue?vue&type=style&index=0&id=5d9d14f0&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__